import { useEffect, Fragment } from 'react';
import { loginUser } from '../../services/UserService';
import { authService } from '../../services/AuthService';
import { useMsal } from "@azure/msal-react";
import Loading from '../components/Loading';
import { useNavigate } from 'react-router-dom';
import { EventType } from '@azure/msal-browser';
import { useAuth } from '../../context/AuthContext';

const LoginPage = () => {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const { setUserLoggedIn } = useAuth();

  useEffect(() => {
    instance.addEventCallback(async (event) => {
      if (event.eventType === EventType.LOGIN_SUCCESS) {
        await handleLogin(event.payload);
      } else if (event.eventType === EventType.LOGIN_FAILURE ||
        event.eventType === EventType.LOGIN_CANCEL) {
        sessionStorage.removeItem('isloading');
        console.error("Login failed:", event.error);
      } else if (event.eventType === EventType.LOGOUT_SUCCESS || event.eventType === EventType.LOGOUT_FAILURE) {
        sessionStorage.removeItem('msalHomeAccountID');
        sessionStorage.removeItem('isloading');
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogin = async (response) => {
    try {
      // Get MSAL access token
      const accessToken = await authService.acquireToken();
      
      const user = {
        account: {
          userName: response.account.username,
        },
        token: accessToken
      };
      
      await loginUser(user).then(() => {
        setUserLoggedIn();
        sessionStorage.setItem('msalHomeAccountID', response.account.homeAccountId);
        sessionStorage.removeItem('isloading');
        navigate('/home', { replace: true });
      }).catch((error) => {
        console.error("Login failed:", error);
      });
    } catch (error) {
      console.error("Redirect failed:", error);
    }
  }

  const login = async () => {
    if (process.env.REACT_APP_SSO_ENABLED !== "false") {
      try {
        sessionStorage.setItem('isloading', 'true');
        await authService.login();
      } catch (error) {
        console.error("MSAL Login failed:", error);
      }
    } else if (process.env.REACT_APP_SSO_ENABLED === "false") {
      const user = {
        account: {
          userName: "userTest",
        },
      };
      setUserLoggedIn();
      await loginUser(user);
      navigate('/home');
    }
  }

  return (
    <Fragment>
      {
        (sessionStorage.getItem('isloading') === 'true'
          ? <Loading />
          :
          <div>
            <div className="d-flex heading-container justify-content-center align-items-baseline">
              <div className="gw__nav_links d-flex">
                <h1 className="gw__nav-logo mb-0">
                  <span className="gw__nav-title-go">Go</span>
                  <span className="gw__nav-title-work">Work</span>
                  <span className="gw__nav-title-dot">.</span>
                </h1>
                <div className="pl-3 mt-3 gw__nav-subtitle" >Immigration Hub</div>
              </div>
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <button className="btn btn-primary mt-5" onClick={login}>
                Sign In
              </button>
            </div>
          </div>
        )}
    </Fragment>
  );
};

export default LoginPage;
